import { UserCircleIcon } from '@heroicons/react/24/outline';
import { Login, Logout, Person, Settings } from '@mui/icons-material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { EUserRoles } from '../../enums/EUserRoles';
import { PageRoutes } from '../../enums/enums';
import CButton from '../CButton';
import CLocalizedText from '../CLocalizedText';
import I18nButton from '../I18nButton';
import XDButton from '../buttons/XDButton';
import XDDropdown from '../selection/XDDropdown';
import XDDropdownItem from '../selection/XDDropdownItem';

interface Props {
  hasNotifications?: boolean;
}

export default function LogoutElement(props: Props) {
  const { keycloak } = useKeycloak();
  const roles = keycloak.tokenParsed?.realm_access?.roles ?? [];
  const showBell =
    roles.includes(EUserRoles.STAFF) ||
    roles.includes(EUserRoles.ADMIN) ||
    roles.includes(EUserRoles.PORTFOLIO_MANAGER);
  const navigate = useNavigate();
  return (
    <div className={'flex items-center gap-2'}>
      <div className={'hidden md:block'}>
        <I18nButton />
      </div>
      {showBell && (
        <div className={'hidden md:block'}>
          <Link to={`/${PageRoutes.NOTIFICATIONS_OUTLET}`} className={'text-base-text-color'}>
            <CButton
              style={{
                borderRadius: '100%',
                aspectRatio: 1,
                padding: '0.8rem 0.75rem 0.8rem 0.85rem',
                justifyContent: 'center',
                textAlign: 'center',
                position: 'relative'
              }}
            >
              <NotificationsNoneIcon style={{ fontSize: '125%', marginTop: '-2px' }} />
              {!!props.hasNotifications && (
                <span className="absolute top-2.5 right-2.5 w-1.5 h-1.5 bg-red-500 rounded-full" />
              )}
            </CButton>
          </Link>
        </div>
      )}
      <XDDropdown
        button={
          <>
            {keycloak.authenticated && (
              <XDButton className={'bg-gray-100 aspect-square font-bold'} style={{ borderRadius: '100%' }}>
                {[keycloak.tokenParsed?.given_name[0], keycloak.tokenParsed?.family_name[0]].filter((e) => e).join('')}
              </XDButton>
            )}
            {!keycloak.authenticated && (
              <XDButton
                className={'bg-gray-100 aspect-square font-bold'}
                style={{ borderRadius: '100%', color: 'rgba(0, 0, 0, 0.6)' }}
              >
                <UserCircleIcon style={{ height: '1.5rem' }} />
              </XDButton>
            )}
          </>
        }
      >
        {keycloak.authenticated && (
          <>
            <XDButton
              className={
                'normal-case hover:bg-opacity-0 hover:text-inherit whitespace-nowrap flex-col items-stretch gap-y-0 text-left'
              }
              style={{ paddingTop: 0, cursor: 'default' }}
            >
              <h6 className={'text-xl'}>
                {[keycloak.tokenParsed?.given_name, keycloak.tokenParsed?.family_name].filter((e) => e).join(' ')}
              </h6>
              <p className={'text-sm'}>{keycloak.tokenParsed?.email}</p>
            </XDButton>

            <XDDropdownItem
              onClick={() => {
                navigate(`${PageRoutes.SELF_MANAGE_ACCOUNT}`);
              }}
            >
              <Settings />
              <CLocalizedText dictKey={'globalManageAccount'} />
            </XDDropdownItem>
            <XDDropdownItem
              onClick={() => {
                keycloak.logout().then();
              }}
            >
              <Logout />
              <CLocalizedText dictKey={'globalLogOut'} />
            </XDDropdownItem>
          </>
        )}
        {!keycloak.authenticated && (
          <>
            <XDDropdownItem
              onClick={() => {
                keycloak.login().then();
              }}
            >
              <Login />
              <CLocalizedText dictKey={'globalLogIn'} />
            </XDDropdownItem>
            <XDDropdownItem
              onClick={() => {
                navigate(`${PageRoutes.SIGN_UP_OUTLET}`);
              }}
            >
              <Person />
              <CLocalizedText dictKey={'signUp.title'} />
            </XDDropdownItem>
          </>
        )}
      </XDDropdown>
    </div>
  );
}
